import { AppState } from "../app.state";

export const getResetPasswordStatus = (state: AppState) => state.resetPassword.loadStatus;
